import React from 'react';
import { CheckCircle, ErrorRounded } from '@mui/icons-material';
import Typography from '../../Typography';

interface HintProps {
  valid: boolean;
  text: string;
  id?: string;
}

function Hint({ valid, text, id }: HintProps) {
  return (
    <li id={id} className="flex items-center">
      {valid ? (
        <CheckCircle className="check-password-hint shrink-0 text-primary mr-1 translate-y-[3px] text-sm" />
      ) : (
        <ErrorRounded className="error-password-hint shrink-0 text-error-medium mr-1 translate-y-[3px] text-sm" />
      )}
      <Typography variant="caption" className="text-neutral-dark">
        {text}
      </Typography>
    </li>
  );
}

export default Hint;
